/**
 * Aggregates all widget CSS into a single string for injection
 */

import base from './base.css';
import panel from './panel.css';
import searchBar from './search-bar.css';
import suggest from './suggest.css';
import filters from './filters.css';
import results from './results.css';
import productCard from './product-card.css';
import cropOverlay from './crop-overlay.css';
import states from './states.css';

const ALL_STYLES = [
  base,
  panel,
  searchBar,
  suggest,
  filters,
  results,
  productCard,
  cropOverlay,
  states,
];

export function getAllCss() {
  return ALL_STYLES.map((mod) => (typeof mod === 'string' ? mod : mod.toString())).join('\n');
}
